import { combineReducers, configureStore } from '@reduxjs/toolkit';

import User from '../Slices/User';
import BackyardOrderCondition from '../Slices/BackyardOrderCondition';

const rootReducer = combineReducers({
  User: User.reducer,
  BackyardOrderCondition: BackyardOrderCondition.reducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;